import { Card, ProgressBar } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { SalesFunnelItem } from "../../types/Indicators.types"

interface SalesFunnelProps {
  data: SalesFunnelItem[]
  title?: string
}

export default function SalesFunnel({ data, title }: SalesFunnelProps) {
  const { t } = useTranslation("global")
  const maxCount = Math.max(...data.map(d => d.count), 1)

  return (
    <Card className="shadow-sm border-0 h-100">
      <Card.Header className="bg-white border-bottom">
        <h6 className="mb-0">
          <i className="fas fa-filter me-2 text-primary" />
          {title || t("Sales Funnel")}
        </h6>
      </Card.Header>
      <Card.Body>
        {data.map((item, i) => (
          <div key={item.statusId} className="mb-3">
            <div className="d-flex justify-content-between mb-1">
              <span className="small">
                {item.icon && <i className={`fas ${item.icon} me-1`} style={{ color: item.color || "#6c757d" }} />}
                {item.statusName}
              </span>
              <span className="small fw-bold">
                {item.count} ({item.percentage}%)
              </span>
            </div>
            <ProgressBar
              now={(item.count / maxCount) * 100}
              style={{ height: 8 }}
              variant={undefined}
              className="bg-light"
            >
              <ProgressBar
                now={(item.count / maxCount) * 100}
                style={{ backgroundColor: item.color || "#0d6efd" }}
              />
            </ProgressBar>
          </div>
        ))}
        {data.length === 0 && (
          <div className="text-center text-muted py-4">{t("No data available")}</div>
        )}
      </Card.Body>
    </Card>
  )
}
